import React from 'react';
import { connect } from "react-redux";
import { AppActions, IState, OpenFileInfo} from '../../types/types'
import CircularProgress from '@mui/material/CircularProgress';
import { pdfMode } from '../../types/enums';
import { PDFTron } from './pdfTron';
import { ThunkDispatch } from 'redux-thunk';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import store from '../../configureStore';

interface PdfFileProps 
{
    PdfFile: OpenFileInfo|null,
    pdfViewerInitializing: boolean,
    pdfViewerClientSide: boolean,
    pdfViewerLoadFailed: boolean,
    pdfViewerMode: pdfMode,
    handleClosePdfViewer: () => void;
  }

const PdfFile = (props:PdfFileProps) => {

  console.log("Render PdfFile info")

  if(props.pdfViewerLoadFailed)
  {
    <div className="material-table-outer-container">
                                                              <div>
                                                                <IconButton
                                                                    edge="end"
                                                                    aria-label="close"
                                                                    onClick={()=>{
                                                                        props.handleClosePdfViewer();
                                                                    }}
                                                                    color="inherit"
                                                                    >
                                                                    <CloseIcon />
                                                                </IconButton>
                                                              </div>
                                                              <div  className="ErrorDiv">
                                                                <pre>{JSON.stringify(JSON.parse(store.getState().uiItems.errorMessage), null, 2) }</pre>
                                                              </div>
                                                          </div>
  }
  if(props.pdfViewerInitializing && !props.pdfViewerLoadFailed)
  {
    return  <div className="material-table-outer-container">
              <CircularProgress />
            </div>
  }
  return <PDFTron PdfFile={props.PdfFile!} ClientSide={props.pdfViewerClientSide} mode={props.pdfViewerMode} handleClosePdfViewer={props.handleClosePdfViewer} />
}

const mapStateToPropsPdfFile = (state:IState) => { 
  return {
   pdfViewerLoadFailed: state.uiState.PDF_VIEWER_CONTAINER_HasErrored,
   pdfViewerInitializing: state.uiState.PDF_VIEWER_INIT_IsLoading,
   PdfFile: state.uiItems.OpenFileInfo,
   pdfViewerClientSide: state.uiItems.pdfViewerClientSide,
   pdfViewerMode: state.uiItems.pdfViewerMode,
}}

const mapDispatchToPropsPdfFile = (dispatch:ThunkDispatch<IState,undefined,AppActions>)  => ( {})

export default connect(mapStateToPropsPdfFile,mapDispatchToPropsPdfFile)(PdfFile) 
  